import { render, staticRenderFns } from "./Talente.vue?vue&type=template&id=b9484c9c&scoped=true&"
import script from "./Talente.vue?vue&type=script&lang=js&"
export * from "./Talente.vue?vue&type=script&lang=js&"
import style0 from "./Talente.vue?vue&type=style&index=0&id=b9484c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9484c9c",
  null
  
)

export default component.exports